






























































































































































































































// 3rd party libs
import {
    mapActions,
    mapGetters,
} from 'vuex';

import loadingSpinner from '@webapp/components/loading-spinner/loading-spinner.vue';
import chips from '@webapp/components/chips.vue';
import search from '@webapp/components/search.vue';

export default {
    name: 'subcategory-filter-sheet',
    components: {
        search,
        loadingSpinner,
        chips,
    },
    props: {
        closeModal: {
            type: Function,
            default: null,
        },
    },
    data() {
        return {
            pagination: 1,
            isScrollLoading: false,
            isLoading: true,
            searchText: '',
            searchedSubCategories: [],
            selectedSubCategories: [],
            productsSubCategories: [],
        };
    },
    computed: {
        ...mapGetters('fanshop', ['getProductSubCategoriesById', 'getSubCategoriesFilterById']),

        isClearEnabled() {
            return this.selectedSubCategories?.length;
        },

        isAllSubCategorySelected() {
            return this.selectedSubCategories.length === 0;
        },
    },
    mounted() {
        this.productsSubCategories = Object.values(this.getProductSubCategoriesById);
        this.selectedSubCategories = this.productsSubCategories.filter((subCategory) => this.getSubCategoriesFilterById.includes(subCategory.id));

        this.search();
    },
    methods: {
        ...mapActions('fanshop', ['updateSubCategoriesFilterById']),


        onTextCleared() {
            this.isLoading = true;
            this.searchText = '';
            this.search(0);
        },

        onTextUpdated(text: string) {
            if (!text?.trim() || text?.trim() === this.searchText?.trim()) {

                return;
            }

            this.isLoading = true;
            this.searchText = text;

            if (text?.trim()) {
                this.searchedSubCategories = this.productsSubCategories.filter((subCategory) => {
                    const cleanText = this.clean(text);

                    return this.clean(subCategory.name).includes(cleanText);
                });
            }
            this.search(0);
        },

        clearSelected() {
            if (!this.isClearEnabled) {

                return;
            }

            this.isLoading = true;
            this.selectedSubCategories = [];

            if (this.searchText && this.$refs.searchbar) {
                this.$refs.searchbar?.clearText();
            }
        },

        search(pagination: number) {
            if (pagination === 0) {
                this.productsSubCategories = [];
                this.pagination = 1;
            }

            let newIndex = 35,
                subCategoriesPerPage = 25,
                subCategoriesVisible = 25;

            if (this.pagination > 1) {
                subCategoriesPerPage = 15;
                subCategoriesVisible = 25 + (subCategoriesPerPage * (this.pagination - 1));
                newIndex = subCategoriesVisible + subCategoriesPerPage;
            }

            const subCategorySource = this.searchText ? this.searchedSubCategories : Object.values(this.getProductSubCategoriesById);

            const maxSourceIndex = subCategorySource.length;

            // We set a timeout to let the drawer appear before the "loading lag" occurs
            setTimeout(() => {
                this.productsSubCategories.push(...subCategorySource.slice(
                    this.productsSubCategories.length,
                    newIndex <= maxSourceIndex ? newIndex : maxSourceIndex
                ));
                this.isLoading = false;
                this.isScrollLoading = false;
            }, 800);
        },

        onScroll(e) {
            const subCategorySource = this.searchText?.trim() ? this.searchedSubCategories : Object.values(this.getProductSubCategoriesById);

            if (this.isScrollLoading || this.productsSubCategories.length === subCategorySource.length) {
                return;
            }

            if (e.target.scrollHeight && e.target.scrollTop && e.target.scrollHeight - (e.target.clientHeight + e.target.scrollTop) <= 40) {
                this.isScrollLoading = true;
                this.search(++this.pagination);
            }
        },

        clean(str: string) {
            // Remove accents, spaces and special chars
            return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                .replace(/([^\w]+|\s+)/g, '')
                .toLowerCase();
        },

        onSubCategorySelect(selectedSubCategory) {
            const subCategoryAlreadyIn = this.selectedSubCategories.some((subCategory) => selectedSubCategory.id === subCategory.id);

            if (subCategoryAlreadyIn) {
                this.removeSelectedSubCategory(selectedSubCategory);
            } else {
                this.selectedSubCategories.push(selectedSubCategory);
            }
        },

        removeSelectedSubCategory(removedSubCategory) {
            this.selectedSubCategories = this.selectedSubCategories.filter((subCategory) => subCategory.id !== removedSubCategory.id);

        },

        isSubCategorySelected(subCategory) {
            return this.selectedSubCategories.some((selectedSubCategory) => selectedSubCategory.id === subCategory.id);
        },
        addHashToLocation(params, clear) {
            window.history.replaceState(
                {},
                null,
                clear ? this.$route.path : this.$route.path + '#' + params
            );
        },
        onAllSubCategorySelect() {
            this.selectedSubCategories = [];
        },

        onValidate() {
            const selectedSubCategoriesIds = [];

            this.selectedSubCategories.forEach((subCategory) => {
                selectedSubCategoriesIds.push(subCategory.id);
            });

            const searchParams = new URLSearchParams({
                selected: selectedSubCategoriesIds.join(','),
            });

            this.addHashToLocation(searchParams.toString(), selectedSubCategoriesIds?.length === 0);

            this.updateSubCategoriesFilterById(selectedSubCategoriesIds);

            this.closeModal();
        },
    },
};
